export default __webpack_public_path__ + "static/media/lockerRed.841373bd.png";